import { useEffect, useMemo, useState } from "react";
import { httpConfig } from "./httpConfig";
import { RequestFetch } from "./config/requestFetch";
import { useLocation, useNavigate } from "react-router-dom";
import { ProtectedLogin } from "./protectedlogin";
import { Icon } from "@iconify/react/dist/iconify.js";
import Cookies from "universal-cookie";
import { Addquerystring } from "./config/addquerystring";
import { Addmetatags } from "./config/addmetatags";

const LoginFormapage = (props) => {
  const location = useLocation();
  const cookies = new Cookies();
  const [username, setUsername] = useState(null);
  const [password, setPassword] = useState(null);
  const [isnull, setIsnull] = useState(false);
  const http = httpConfig();
  const navigat = useNavigate();

  const getIddoc = (id) => {
    return document.getElementById(id);
  };

  const handlecheckidpass = () => {
    if (username === null || password === null || !username || !password) {
      console.log("ยังไม่ได้กรอกข้อมูล username password");
      setIsnull(true);
      if (!username) {
        getIddoc("inputlogin-username").classList.add("inputlogin-red");
        getIddoc("inputlogin-username").style.border = "3px solid #e51c23";
        getIddoc("inputlogin-username").classList.add("handleerrorInputnull");
        setTimeout(() => {
          getIddoc("inputlogin-username").classList.remove(
            "handleerrorInputnull"
          );
        }, 400);
      } else {
        getIddoc("inputlogin-username").style.border = "3px solid #dedede";
        getIddoc("inputerrorshow-username").style.display = "none";
      }

      if (!password) {
        getIddoc("inputlogin-password").classList.add("inputlogin-red");
        getIddoc("inputlogin-password").style.border = "3px solid #e51c23";
        getIddoc("inputlogin-password").classList.add("handleerrorInputnull");
        setTimeout(() => {
          getIddoc("inputlogin-password").classList.remove(
            "handleerrorInputnull"
          );
        }, 400);
      } else {
        getIddoc("inputlogin-username").classList.remove("inputlogin-red");
        getIddoc("inputlogin-password").classList.remove("inputlogin-red");
        getIddoc("inputlogin-password").style.border = "3px solid #dedede";
        getIddoc("inputerrorshow-password").style.display = "none";
      }
    } else {
      setIsnull(false);
      getIddoc("inputlogin-username").style.border = "3px solid #dedede";
      getIddoc("inputlogin-password").style.border = "3px solid #dedede";
      getIddoc("inputerrorshow-username").style.display = "none";
      getIddoc("inputerrorshow-password").style.display = "none";
      handlefetchcheckusernamepassword(username, password);
    }
  };

  const handleNodatasomethingwrong = () => {
    getIddoc("inputlogin-username").style.border = "3px solid #e51c23";
    getIddoc("inputlogin-username").classList.add("handleerrorInputnull");
    getIddoc("inputlogin-password").style.border = "3px solid #e51c23";
    getIddoc("inputlogin-password").classList.add("handleerrorInputnull");
    getIddoc("inputerrorshow-username").style.display = "block";
    getIddoc("inputerrorshow-password").style.display = "block";
    setTimeout(() => {
      getIddoc("inputlogin-username").classList.remove("handleerrorInputnull");
      getIddoc("inputlogin-password").classList.remove("handleerrorInputnull");
    }, 400);
  };

  const handlefetchcheckusernamepassword = (id, pass) => {
    fetch(
      `${http}/loginform`,
      RequestFetch("POST", { id: id, pass: pass })
    ).then((res) => {
      if (res.ok) {
        res.json().then((result) => {
          // console.log(result);
          if (result.message_status) {
            props.handleSetid_advisor(
              result.data[0].adv_id,
              result.data[0].pin
            );
            navigat(`/pinlogin?timestamp=${new Date().getTime()}`);
          } else {
            handleNodatasomethingwrong();
          }
        });
      }
    });
  };

  useEffect(() => {
    Addmetatags();
    // cookies.remove("tokenEstiamte");
    // localStorage.clear();
    // Addquerystring(`${httpConfig()}/estimate`);
    if (cookies.get("tokenEstimate")) {
      navigat(`listwork?timestamp=${new Date().getTime()}`);
    }
  }, [location.search]);

  return (
    <div className="loginformpage-body">
      <form
        onSubmit={(e) => {
          e.preventDefault();
          handlecheckidpass();
        }}
      >
        <div className="loginformpage-loginbox">
          <h1>{"EyeEstimate"}</h1>
          <div className="logindisplaygrid-box">
            {/* <span>{"ชื่อผู้ใช้"}</span> */}
            <div className="thisboxinput-loginform">
              <div className="boxicon">
                <Icon icon="bxs:user" />
              </div>
              <input
                type="text"
                id="inputlogin-username"
                autoComplete="off"
                placeholder={
                  isnull
                    ? !username
                      ? "กรุณากรอก ชื่อผู้ใช้งาน"
                      : ""
                    : "username"
                }
                onFocus={(e) => {
                  e.target.select();
                }}
                onChange={(e) => {
                  setUsername(e.target.value);
                }}
              ></input>
            </div>
            <span className="showerror-input" id="inputerrorshow-username">
              {"กรุณาตรวจสอบชื่อผู้ใช้งาน"}
            </span>
          </div>
          <div className="logindisplaygrid-box">
            {/* <span>{"รหัสผ่าน"}</span> */}
            <div className="thisboxinput-loginform">
              <div className="boxicon">
                <Icon icon="mdi:password" />
              </div>
              <input
                id="inputlogin-password"
                type="password"
                onFocus={(e) => {
                  e.target.select();
                }}
                placeholder={
                  isnull ? (!password ? "กรุณากรอก รหัสผ่าน" : "") : "password"
                }
                onChange={(e) => {
                  setPassword(e.target.value);
                }}
              ></input>
            </div>

            <span className="showerror-input" id="inputerrorshow-password">
              {"กรุณาตรวจสอบรหัสผ่าน"}
            </span>
          </div>
          <div className="btn-logintopin">
            <button type="submit">{"เข้าสู่ระบบ"}</button>
          </div>
        </div>
      </form>
    </div>
  );
};
export default LoginFormapage;
